import { container_classname } from "@components/new-ui/constants";
import CTAButtons from "@components/new-ui/CTAButtons";

import Image from "next/image";

export interface HeroSectionProps {
    chipTitle?: string;
    title: string;
    description?: string;
    primaryButtonText: string;
    imageUrl: string;
    imgAlt: string;
}

export const Herosection: React.FC<HeroSectionProps> = ({ chipTitle, title, description, primaryButtonText, imageUrl, imgAlt }) => {
    return (
        <section style={{ background: " linear-gradient(265deg, #396AFF -7.73%, #00238D 61.31%, #000 102.16%)" }}>
            <div className={`${container_classname} flex md:flex-row flex-col md:py-20 md:pt-40 py-12 gap-28`}>
                <div className="md:w-1/2">
                    {chipTitle && (
                        <a href="/alternatives" className="text-2xl lg:flex font-normal mb-3 md:block hidden hover:no-underline cursor-pointer" style={{ color: "#00DFFF" }}>
                            {chipTitle}
                        </a>
                    )}
                    <h1 className="md:text-6xl text-5xl mb-5 font-bold text-white" style={{ fontFamily: "Degular Variable" }}>
                        {title}
                    </h1>
                    {description && <p className="text-xl font-normal text-white mb-12">{description}</p>}
                    <CTAButtons primaryButtonText={primaryButtonText} className={`${!description && "mt-8"}`} />
                </div>

                <Image width={450} height={520} src={imageUrl} alt={imgAlt} className="mb-auto" />
            </div>
        </section>
    );
};
